/**
 * Show time in seconds as mm:ss or hh:mm:ss
 *
 * @param {number} timeInSeconds - The time in seconds
 * @param {boolean} ignoreHours - If true, timestamp will always be mm:ss even for great numbers
 *
 * @example
 * console.log(toMinutes(244)); // 04:04
 * console.log(toMinutes(7800)); // 02:10:00
 * console.log(toMinutes(7800, true)); // 130:00
 */
const toTimestamp = (timeInSeconds: number, ignoreHours?: boolean) => {
  let minutes = Math.floor(timeInSeconds / 60);
  const seconds = Math.ceil(timeInSeconds - minutes * 60);

  if (!ignoreHours && minutes >= 60) {
    const hours = Math.floor(minutes / 60);

    minutes = Math.ceil(minutes - hours * 60);
    return `${`0${hours}`.slice(-2)}:${`0${minutes}`.slice(
      -2,
    )}:${`0${seconds}`.slice(-2)}`;
  }
  return `${
    ignoreHours && minutes >= 10 ? minutes : `0${minutes}`.slice(-2)
  }:${`0${seconds}`.slice(-2)}`;
};

export default toTimestamp;
